import { PageQuery } from './common.model';
import { ShopInfo } from './users.model';

export interface Product {
  id: number;
  name: string;
  productCode: string;
  isCombo: boolean;
  image: string;
  price: number;
  commissionPrice: number;
  quantity: number;
  accumulateAmount: number;
  description: string;
  noted: string;
  isEnable: boolean;
  categoryId: number;
  shop?: ShopInfo;
  rating: number;
  salePrice: number;
  saleQuantity: number;
  endDate: string;
  startDate: string;
}

export interface ProductDetail extends Product {
  imageDetails: string[];
  totalSold: number;
  totalFeedback: number;
  productType: ProductQueryType;
  categoryId: number;
  cashback: number;
}

export interface Category {
  id: number;
  name: string;
}

export enum ProductQueryType {
  shop = 'SHOP', //N16/products/shop
  retail = 'RETAIL',
  vip = 'VIP',
  admin = 'ADMIN', //N061/products,
  sale = 'SALE', //N063/products
  nutriShop = 'NUTRIDAYSHOP', //N06/products/shop
  dynamic = 'DYNAMIC', //N16/products/dynamic
  activeUser = 'ACTIVE_USER', //new
  activeShop = 'ACTIVE_SHOP', //new
  all = '',
}

export interface ProductSearchQuery extends PageQuery {
  productType: ProductQueryType[];
  keyword: string;
  categoryId: number[];
}

export interface ProductNutriShopSearchQuery extends PageQuery {
  productName: string;
  nutrishopId: number;
  approved?: boolean;
}

export interface Feedback {
  comment: string;
  rating: number;
  image: string;
  user: {
    avatar: string;
    fullName: string;
  };
}

export interface CreateFeedbackRequest {
  comment: string;
  rating: number;
  image: string;
  productId: number;
  orderId: number;
}

export type FeedbackSearchQuery = PageQuery;

export interface UpdateProductRequest {
  productId: number;
  image: string;
  description: string;
  imageDetails: string[];
}

export interface CreateFlashSaleRequest {
  productId: number;
  salePrice: number;
  saleQuantity: number;
  startDate: string;
  endDate: string;
  buyLimit: number;
}

export interface FlashSale {
  salePrice: number;
  saleQuantity: number;
  startDate: string;
  endDate: string;
  buyLimit: number;
}

export interface ProductCategory {
  id: number;
  name: string;
  image: string;
  priority: number;
}

export interface ProductForm {
  name: string;
  image: string;
  imageDetails: string[];
  price: number | '';
  commissionPrice: number | '';
  quantity: number | '';
  description: string;
  noted: string;
  categoryId: number | '';
  isEnable: boolean;
  cashback: number | '';
  productType: ProductQueryType;
  id?: number;
}
